import { Deal } from 'modules/domain/deal/types'

export const hasBaseCreditData = (deal: Deal) =>
  deal.purchase_bid.company.affectable_turnover_days && deal.purchase_bid.company.turnover_days
